module.exports = __webpack_public_path__ + "media/images/continuing-education-d6fd8c66ce0c7755d1b847a61a7d85da.svg";